<template>
  <div class="search">
    <div class="d-flex justify-content-start" :class="{ normal: !(isMobile || isTablet) }">
      <select-input
        class="type"
        :items="searchTypeOptions"
        v-model="searchType"
        ref="searchTypeInput"
        borderless
      />
      <text-input
        :placeholder="$t('SEARCH_BY_NAME_ID_PASSPORT_PHONE_NUMBER_MIFOS_ID')"
        borderless
        v-model="terms"
        @keyup.enter="search"
      >
      </text-input>
    </div>
  </div>
</template>

<script>
import TextInput from '@/components/TextInput';
import SelectInput from '@/components/SelectInput';
import { computed, ref, getCurrentInstance } from '@vue/composition-api';
import { createNamespacedHelpers } from 'vuex-composition-helpers';
import { PATHS } from '@/consts';

const { useActions: useSearchActions } = createNamespacedHelpers('searchResult');
const { useState: useAppState } = createNamespacedHelpers('app');

export default {
  name: 'Search',
  components: {
    TextInput,
    SelectInput,
  },
  setup(props, { root: { $router }, emit }) {
    const vm = getCurrentInstance();
    const { setSearchField } = useSearchActions(['setSearchField']);
    const { isMobile, isTablet } = useAppState(['isMobile', 'isTablet']);

    const searchType = ref('all');
    const searchTypeInput = ref(null);
    const terms = ref('');

    const searchTypeConst = [
      {
        text: 'ALL',
        value: 'all'
      },
      {
        text: 'CLIENTS',
        value: 'clients'
      },
      {
        text: 'CONTRACTS',
        value: 'contracts'
      }
    ];
    const searchTypeOptions = computed(() => searchTypeConst.map((item) => ({
      text: vm.$i18n.t(item.text),
      value: item.value
    })));

    const search = () => {
      setSearchField({
        searchType: searchType.value,
        terms: terms.value
      });
      $router.push({ path: PATHS.SEARCH, query: { type: searchType.value, terms: terms.value } }).catch(() => {});
      emit('searching');
    };

    return {
      searchTypeOptions,
      searchType,
      searchTypeInput,
      search,
      terms,
      isMobile,
      isTablet,
    };
  },
};
</script>

<style lang='scss' scoped>
@import "~@/assets/scss/colors";

.search {
  .normal {
    /deep/ .text-input {
      width: 400px;
      height: 45px;

      @media (max-width: 1150px) {
        width: 350px;
      }

      @media (max-width: 1065px) {
        width: 250px;
      }

      input {
        border-radius: 23px;
      }
    }

    /deep/ .select-input {
      width: 130px;
      border-color: $alto;
      height: 45px;
      border-right: 1px solid $alto ;

      .display {
        text-align: center;
        padding-left: 5px;
        padding-right: 20px;
      }
    }
  }

  .type {
    width: 178px;
    background: $white;
  }

}
</style>
